import React from 'react';

function ImportSVG() {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V3C20 1.34315 18.6569 0 17 0H15C14.4477 0 14 0.447716 14 1C14 1.55228 14.4477 2 15 2H17C17.5523 2 18 2.44772 18 3V17C18 17.5523 17.5523 18 17 18H3C2.44772 18 2 17.5523 2 17V3C2 2.44772 2.44772 2 3 2H5C5.55228 2 6 1.55228 6 1C6 0.447716 5.55228 0 5 0H3C1.34315 0 0 1.34315 0 3V17Z" />
      <path d="M5.29289 9.70711L9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071L14.7071 9.70711C15.0976 9.31658 15.0976 8.68342 14.7071 8.29289C14.3166 7.90237 13.6834 7.90237 13.2929 8.29289L11 10.5858V1C11 0.447715 10.5523 0 10 0C9.44772 0 9 0.447715 9 1V10.5858L6.70711 8.29289C6.31658 7.90237 5.68342 7.90237 5.29289 8.29289C4.90237 8.68342 4.90237 9.31658 5.29289 9.70711Z" />
    </svg>
  );
}

export default ImportSVG;
